// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { DefaultGet } from '../../../../types/server/modules/default/get';

export type * from '../../../../types/server/modules/default/get';

export const createGet = ( requests: Requests ): DefaultGet => ({
  echo_auth_headers: ( headers ) => {
      return requests.get( `/dev-utils/echo-auth-headers`, undefined, headers );
    },
  spreadsheet_bench_get_grid: ( params,headers ) => {
      return requests.get( `/dev-utils/spreadsheet-bench/:gridId`, params, headers );
    },
  whoami: ( headers ) => {
      return requests.get( `/dev-utils/whoami`, undefined, headers );
    },
  list_events: ( params,headers ) => {
      return requests.get( `/dev-utils/events`, params, headers );
    },
  get_watermark_state: ( params,headers ) => {
      return requests.get( `/admin/api/outbox/get-watermark-state/:subscriptionId`, params, headers );
    },
  get_errored_streams: ( params,headers ) => {
      return requests.get( `/admin/api/outbox/get-errored-streams/:subscriptionId`, params, headers );
    },
  get_event: ( params,headers ) => {
      return requests.get( `/admin/api/outbox/get-event/:subscriptionId`, params, headers );
    },
  get_subscription_state: ( params,headers ) => {
      return requests.get( `/admin/api/outbox/get-subscription-state/:subscriptionId?`, params, headers );
    }
});
